<template>
  <div class="breadcrumb-component">
    <a
      v-for="(item, index) in paths"
      :key="index"
      :href="item.href || 'javascript:;'"
      :class="{'a-auto': index === paths.length - 1}"
      vkshop-event-name="breadCrumb"
      :vkshop-event-param="'name=' + item.name"
      vkshop-event-type="click"
    >
      {{item.name}}
      <span v-if="index !== paths.length - 1"> > </span>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    paths: {
      type: Array,
      default: function () {
        return []
      }
    }
  }
}
</script>

<style lang="less" scoped>
.breadcrumb-component {
  a {
    color: #999;
    &:hover {
      font-weight: 600;
    }
    &.a-auto {
      color: #333333;
      &:hover {
        font-weight: normal;
      }
    }
  }
}
</style>
